module.exports = __webpack_public_path__ + "media/scholarship_winners/briana-b-0f4ea895.png";